import { render, staticRenderFns } from "./filter-box.vue?vue&type=template&id=5d8fbde1&scoped=true"
import script from "./filter-box.vue?vue&type=script&lang=js"
export * from "./filter-box.vue?vue&type=script&lang=js"
import style0 from "./filter-box.vue?vue&type=style&index=0&id=5d8fbde1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8fbde1",
  null
  
)

export default component.exports